<template>
  <div>
    <div class="columns is-vcentered">
      <div class="column is-narrow" style="padding-left: 84px;">
        {{ $t("orders.total") }}
      </div>

      <div class="column">
        {{ `${itemsQuantity} ${$tc("orders.items", itemsQuantity)}` }}
      </div>

      <div class="column is-narrow has-text-right">
        <money
          v-model="cart.totalValue"
          v-bind="money"
          readonly
          class="input-price"
        ></money>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "../../mixins/mask";
import { Money } from "v-money";

export default {
  props: ["cart"],

  mixins: [mask],

  components: {
    Money
  },

  data() {
    return {
      NODE_ENV: process.env.NODE_ENV
      // money: {
      //   decimal: ",",
      //   thousands: ".",
      //   prefix: "R$ ",
      //   precision: 2
      // }
    };
  },

  computed: {
    ...mapGetters(["payments"]),

    itemsQuantity() {
      return this.cart.items.reduce((t, c) => {
        return t + c.quantity;
      }, 0);
    },

    money() {
      return {
        decimal: ",",
        thousands: ".",
        prefix: `${this.payments.currencySymbol} `,
        precision: 2
      };
    }
  }
};
</script>

<style scoped>
.quantity-column {
  padding-left: 1rem;
  padding-right: 1rem;
}
.total {
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.input-price {
  all: unset;
}
</style>
